/**
 * Tipos de propriedade cujo valor é um arquivo no Storage, e não um dado no banco.
 *
 * Sem NENHUMA dependência de propósito: o ontosUtils precisa deste predicado, e se
 * ele morasse junto do código de conversão arrastaria o canvas para todo lugar que
 * só quer saber "isto é mídia?". Util não importa service — assim não há ciclo.
 */
export const MEDIA_TYPES = ['image', 'audio']

export function isMediaType(property: { type?: string } | null | undefined): boolean {
    return !!property && !!property.type && MEDIA_TYPES.indexOf(property.type) >= 0
}

/** Para os lugares que têm o tipo solto, sem a propriedade em volta. */
export function isMedia(type: string | undefined | null): boolean {
    return !!type && MEDIA_TYPES.indexOf(type) >= 0
}

export default {MEDIA_TYPES, isMediaType, isMedia}
